import React from 'react'
import type { Observer } from '../../hooks/useWhisperMode'

interface WhisperBannerProps {
  observers: Observer[]
  isObserving: boolean
  onExit: () => void
}

export const WhisperBanner: React.FC<WhisperBannerProps> = ({ observers, isObserving, onExit }) => {
  if (!isObserving) return null

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-amber-50 border-t border-amber-300 dark:bg-amber-900/20 dark:border-amber-700">
      <div className="flex items-center gap-2">
        {/* Eye icon */}
        <svg className="w-4 h-4 text-amber-600 dark:text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
        <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wider">
          Monitoring
        </span>
        {observers.length > 1 && (
          <span className="text-xs text-amber-600 dark:text-amber-500">
            ({observers.length} observers)
          </span>
        )}
      </div>
      <button
        onClick={onExit}
        className="flex items-center gap-1 px-3 py-1 text-xs font-medium text-amber-700 bg-amber-100 rounded-md hover:bg-amber-200 transition-colors dark:text-amber-300 dark:bg-amber-800/40 dark:hover:bg-amber-800/60"
      >
        {/* X icon */}
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
        Exit Whisper Mode
      </button>
    </div>
  )
}
